<template>
    <div class="cpfModal">


        <Dialog v-model:visible="showModalPaiementCpf" modal header="Paiements" :style="{ width: '60rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" appendTo="self">
          <div class="containername">
            <SimpleTypeahead
          id="typeahead_id"
          placeholder="Rechercher un élève..."
          :items="leleves"
          :minInputLength="1"
          :itemProjection="
            (item) => {
              return item.fullname;
            }
          "
          @selectItem="selectItem"
          @onInput="searchEleve"
        >
        </SimpleTypeahead>
            <paiement :data="eleve" v-if="this.eleve != null" :modal="true"/>
          </div>
        </Dialog>


    </div>
  </template>
  
  <script>
  import SimpleTypeahead from "vue3-simple-typeahead";
  import paiement from "@/components/eleve/Paiement.vue";
  export default {
  
      props: [
        "modalCpf",
        "closeModalPaiementCpf",
      ],
  
    components: {
      SimpleTypeahead,
      paiement
    },
  
    watch: {
      showModalPaiementCpf: function () {
      if (this.showModalPaiementCpf == false) {
        this.$emit("closeModalPaiementCpf");
      }
    },
  },
  
    data() {
      return {
        showModalPaiementCpf : false,
        leleves : [],
        eleve : null,
        load : 0,
      };
    },
  
    mounted() {
      this.showModalPaiementCpf = this.modalCpf;
      this.getEleves();
    },
  
    methods: {

      searchEleve(e){
      
        if(e.input.length == 3 || e.input.length == 6 || e.input.length == 9 || e.input.length == 12 || e.input.length == 15 || e.input.length == 18 || e.input.length == 21){
            window.api
            .get("/eleves/agence/planning/search/"+this.$store.state.user.agence.id+"/"+e.input, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              this.leleves = response.data.eleves;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },

      getEleves(){

        let agence = 0;

        if(this.$store.state.user.agence != null){
          agence = this.$store.state.user.agence.id;
        }

        window.api.get("/eleves/agence/planning/" + agence, {
            headers: {
              "Authorization": "Bearer " + this.$store.state.token
            },
          }).then(response => {
            this.eleves = response.data.eleves;
            this.load++;
          }).catch(error => {
            console.log(error)
          })
      },

      selectItem(e){
        this.eleve = null;
        this.eleve = e;
      },  

    }
  };
  </script>
  
<style scoped>
    :deep(.p-dialog) {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        min-height: 40rem;
    }

    :deep(.p-dialog-content) {
        background-color: #fff;
        flex: 1;
    }

    :deep(#typeahead_id) {
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        padding: 10px;
        width: 100%;
    }

    .simple-typeahead :deep(.simple-typeahead-list) {
        position: absolute;
        z-index: 9999;

        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        max-height: 300px;
        overflow-y: auto;
        margin: 0;
        padding: 0;
        list-style: none;
        width: 40%;
    }

    .simple-typeahead :deep(.simple-typeahead-list-item) {
        padding: 8px 12px;
        cursor: pointer;
        font-size: 14px;
    }

    .simple-typeahead :deep(.simple-typeahead-list-item:hover),
    .simple-typeahead
    :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
        background-color: #f0f4ff;
    }
</style>